import(/* webpackMode: "eager" */ "/codebuild/output/src1104476342/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/capital_manager/page.tsx");
